<div class="main-container">
  <div class="bg-container">
    <div class="logo-header">
      <img
        src="../../../../assets/images/brijjworks_logo_primary.svg"
        alt=""
        data-testid="logo-img"
      />
    </div>
    <div class="page-body my-auto">
      <div class="login-form">
        <div class="login-form-wrapper" *ngIf="!toggleForgotPassField">
          <div class="d-flex flex-column align-items-center form-head">
            <h5 class="text-center" data-testid="welcome-title">Welcome Back</h5>
            <span data-testid="welcome-desc"
              >Enter your credentials to access your Brijjworks account
            </span>
          </div>
          <div class="error-msg-container" *ngIf="incorrectLogin" data-testid="login-error">
            <img src="../../../../assets/images/Info.svg" alt="" />
            <span id="invalidInput" class="error-msg"
              >Authentication failed: Incorrect username or password, or your account is
              inactive.</span
            >
          </div>
          <div class="form-wrapper">
            <div class="mb-3 pb-1 mt-4 entre-value">
              <label for="username" class="input-label" data-testid="username-label"
                >Email ID / Username</label
              >
              <div class="input-wrapper">
                <img src="../../../../assets/images/ic-email.svg" />
                <input
                  type="text"
                  class="form-control"
                  name="email"
                  autocomplete="off"
                  [(ngModel)]="loginInfo.email"
                  (keydown.enter)="loginOnEnter($event)"
                  id="username"
                  placeholder="Enter username"
                  aria-describedby="emailHelp"
                  data-testid="username-input"
                />
              </div>
            </div>
            <div class="mb-2 entre-value">
              <label for="username" class="input-label" data-testid="password-label"
                >Password</label
              >
              <div class="input-wrapper">
                <img src="../../../../assets/images/ic-password.svg" />
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control"
                  name="password"
                  autocomplete="new-password"
                  [(ngModel)]="loginInfo.password"
                  placeholder="Enter password"
                  id="exampleInputPassword1"
                  (keydown.enter)="loginOnEnter($event)"
                  data-testid="password-input"
                />
                <button
                  class="btn p-0 border-0"
                  (click)="togglePasswordVisibility1()"
                  [disabled]="!loginInfo.password"
                  data-testid="toggle-password-btn"
                >
                  <img
                    class="c-pt"
                    [src]="
                      showPassword
                        ? '../../../../assets/images/ic-pass_show.svg'
                        : '../../../../assets/images/ic-pass_hide.svg'
                    "
                  />
                </button>
              </div>
            </div>
            <div class="mb-4 d-flex justify-content-end entre-value">
              <span class="forgot-password-text" (click)="toggleForm()" style="padding-block: 4px">
                <a class="c-pt" data-testid="forgot-password-link">Forgot Password?</a>
              </span>
            </div>
          </div>
          <button
            type="submit"
            [disabled]="!isLoginValid() || isLoggingIn"
            (click)="login()"
            class="btn btn-primary btn-adjust"
            data-testid="login-btn"
          >
            <span
              *ngIf="isLoggingIn"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            <span *ngIf="!isLoggingIn">Log In</span>
            <span *ngIf="isLoggingIn">Logging in...</span>
          </button>
        </div>
        <div class="login-form-wrapper" *ngIf="toggleForgotPassField">
          <form>
            <div class="reset-head">
              <div
                class="btn p-0 back-btn c-pt"
                (click)="toggleForm()"
                #loginBtn
                data-testid="back-to-login-btn"
              >
                <img src="../../../../assets/images/back_btn_icon.svg" alt="" />
              </div>
              <div class="d-flex flex-column form-head">
                <h5 class="text-start m-0" data-testid="reset-title">Reset your password</h5>
                <span data-testid="reset-desc"
                  >We will send you an email to reset your password
                </span>
              </div>
            </div>
            <div class="mb-4 pb-1 mt-4 entre-value">
              <label for="username" class="input-label" data-testid="reset-username-label"
                >Email ID / Username</label
              >
              <div class="input-wrapper">
                <img src="../../../../assets/images/ic-email.svg" />
                <input
                  type="text"
                  class="form-control"
                  name="email"
                  [(ngModel)]="loginInfo.userName"
                  id="exampleInputEmail1"
                  placeholder="Enter your username or email"
                  aria-describedby="emailHelp"
                  data-testid="reset-username-input"
                />
              </div>
            </div>
            <button
              type="submit"
              [disabled]="!isResetPasswordEmailValid()"
              class="btn btn-primary btn-adjust my-4"
              (click)="sendEmailForForgetPass()"
              data-testid="reset-email-btn"
            >
              <span>Email Me</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
